module.exports = __webpack_public_path__ + "static/logo-white-47cb6ef88070fb7c54a94115466f1cf0.svg";